import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Seal',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Seal',
        href: '/adm/opr/seal',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_seal',
    sortDesc: true,
    fields: [
      {
        key: 'code_seal',
        sortable: true,
      },
      {
        key: 'tgl_pakai',
        label: 'Keluar',
      },
      {
        key: 'seal_number',
        label: 'Seal',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'doc_no',
        label: 'Booking',
      },
      {
        key: 'vessel',
        label: 'Vessel',
      },
      {
        key: 'voy',
        label: 'Voy',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose: [
      {
        key: 'code_seal',
        sortable: true,
        thStyle: {
          width: '150px',
        },
        tdStyle: {
          padding: '0px',
        },
      },
      {
        key: 'seal_number',
        label: 'Seal',
        sortable: true,
        tdStyle: {
          padding: '0px',
        },
      },
    ],
    detail: false,
    form: {
      seal_number: '',
    },
    except_seal: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeSeal(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchSeal(context, params = null) {
    let result = await ApiGetRequest(`opr/seal`, params);
    return !result.error ? result.data.object : [];
  },

  async getListSeal({ commit, state }) {
    commit('changeSeal', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      not_used: data.not_used ? 1 : 0,
      booking: data.booking ? 1 : 0,
      id_pay_booking: data.id_pay_booking ? data.id_pay_booking : 0,
      id_principle: data.id_principle ? data.id_principle : 0,
      except_seal: data.except_seal ? data.except_seal.join(',') : '',
    };

    let result = await ApiGetRequest(`opr/seal`, params);
    commit('changeSeal', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailSeal({ commit, state }, payload = null) {
    commit('changeSeal', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/seal/${payload.id}`);
    commit('changeSeal', {
      loading: false,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createSeal({ commit, state, dispatch }) {
    commit('changeSeal', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/seal`, state.data.form);
    commit('changeSeal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSeal({ commit, state, dispatch }, payload = null) {
    commit('changeSeal', {
      loading: true,
    });

    let result = await ApiPutRequest(`opr/seal/${payload.id}`, state.data.form);

    commit('changeSeal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteSeal({ commit, dispatch }, payload = null) {
    commit('changeSeal', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/seal/${payload.id}`);
    commit('changeSeal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
